<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding: 0">
      <div class="page-header">
        <h1 class="page-title">Últimas solicitações atendidas</h1>
        <p class="page-subtitle">Histórico de solicitações ao SAMU</p>
      </div>

      <div class="cards-container">
        <div
          @click="view(ocorrencia.ocorrencia_id)"
          class="atendimento-card"
          v-for="ocorrencia in ocorrencias"
          :key="ocorrencia.ocorrencia_id"
          :class="'status-' + getStatusClass(ocorrencia.status)"
        >
          <div class="card-header">
            <div class="card-id">
              <i class="bi bi-clipboard-check"></i>
              Nº da Ocorrência #{{
                ocorrencia.ocorrencia_id_samu
                  ? String(ocorrencia.ocorrencia_id_samu).slice(-4)
                  : ocorrencia.ocorrencia_id
              }}
            </div>
            <div
              class="status-badge"
              :class="'badge-' + getStatusClass(ocorrencia.status)"
            >
              {{ getStatusText(ocorrencia.status) }}
            </div>
          </div>

          <div class="card-content">
            <div class="info-row">
              <div class="info-item">
                <i class="bi bi-calendar-event"></i>
                <div class="info-text">
                  <span class="info-label">Data</span>
                  <span class="info-value">{{ ocorrencia.data_gravacao }}</span>
                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-item">
                <i class="bi bi-person-circle"></i>
                <div class="info-text">
                  <span class="info-label">Vítima</span>
                  <span class="info-value">
                    {{
                      ocorrencia.paciente
                        ? ocorrencia.paciente.nome_paciente
                        : ocorrencia.nome_vitima
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div class="info-row two-columns">
              <div class="info-item">
                <i class="bi bi-hourglass-split"></i>
                <div class="info-text">
                  <span class="info-label">Idade</span>
                  <span class="info-value">
                    {{
                      ocorrencia.paciente
                        ? ocorrencia.paciente.idade
                        : ocorrencia.idade_vitima
                    }}
                  </span>
                </div>
              </div>
              <div class="info-item">
                <i class="bi bi-person-vcard"></i>
                <div class="info-text">
                  <span class="info-label">Sexo</span>
                  <span class="info-value">
                    {{
                      getSexoText(
                        ocorrencia.paciente
                          ? ocorrencia.paciente.sexo
                          : ocorrencia.sexo_vitima
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-item">
                <i class="bi bi-chat-dots"></i>
                <div class="info-text">
                  <span class="info-label">Queixa Principal</span>
                  <span class="info-value queixa-text">
                    {{ ocorrencia.queixa_principal || "Não informado" }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <span class="view-link"
              >Ver detalhes <i class="bi bi-chevron-right"></i
            ></span>
          </div>
        </div>

        <div class="empty-state" v-if="ocorrencias.length == 0">
          <div class="empty-icon">
            <i class="bi bi-inbox"></i>
          </div>
          <h3>Nenhum atendimento solicitado</h3>
          <p>Você ainda não tem histórico de atendimentos.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      isLoading: false,
      loadingColor: "#5D9CEC",
      /* ocorrencias: {
        latitude: 0,
        longitude: 0,
        queixa_principal: "",
        ip: "",
        paciente_id: 0,
        usuario_solicitante_id: 0,
        paciente: {
          nome_paciente: '',
        },
      }, */
      ocorrencias: [],
      usr_id: {
        usuario_id: ""
      },
      usuario_nome: ""
    };
  },
  computed: {
    exibirStatus() {
      return this.ocorrencias.map(ocorrencia => {
        if (ocorrencia.status === 0) {
          return "Solicitado";
        } else if (ocorrencia.status === 1) {
          return "Em Andamento";
        } else if (ocorrencia.status === 2) {
          return "Finalizado";
        } else if (ocorrencia.status === 3) {
          return "Cancelado";
        } else {
          return ocorrencia.status.toString();
        }
      });
    }
  },
  methods: {
    view(id) {
      this.$router.push("/visualizar-atendimento/" + id);
    },
    getOcorrencias(id) {
      const self = this;
      self.isLoading = true;

      this.usr_id.usuario_id = Number(id);
      const api = self.$store.state.api + "usuario-ocorrencias-finalizadas";

      axios
        .post(api, this.usr_id)
        .then(response => {
          self.ocorrencias = response.data;
          self.isLoading = false;
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    getStatusClass(status) {
      switch (status) {
        case 0:
          return "solicitado";
        case 1:
          return "andamento";
        case 9:
          return "finalizado";
        case 99:
          return "cancelado";
        default:
          return "pendente";
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "Solicitado";
        case 1:
          return "Em Andamento";
        case 9:
          return "Finalizado";
        case 99:
          return "Cancelado";
        default:
          return "Pendente";
      }
    },
    getSexoText(sexo) {
      if (sexo === "M") return "Masculino";
      if (sexo === "F") return "Feminino";
      return "Não informado";
    },
    formatDate(date) {
      if (!date) return "Não informado";
      try {
        const d = new Date(date);
        // Validar se a data é válida
        if (isNaN(d.getTime())) return "Não informado";

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} às ${hours}:${minutes}`;
      } catch (error) {
        return "Não informado";
      }
    }
  },
  components: { Loading },
  props: {},
  mounted() {
    const self = this;

    self.isLoading = false;

    var id = localStorage.getItem("usuario_id");

    self.getOcorrencias(id);

    this.authenticated = this.$store.getters.authenticated;

    $("body").removeClass("top-navigation");
    $("body").removeClass("custom-login");

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    /*  var usr_nome = localStorage.getItem('usuario_nome');
    this.usuario_nome = usr_nome; */
  }
};
</script>
<style scoped>
/* LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* HEADER */
.page-header {
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
}

.page-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
  font-weight: 500;
}

/* CONTAINER */
.cards-container {
  padding: 0 12px 100px;
}

/* ATENDIMENTO CARDS */
.atendimento-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 4px solid #d6582c;
  cursor: pointer;
}

.atendimento-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.atendimento-card.status-solicitado {
  border-left-color: #f59e0b;
}

.atendimento-card.status-andamento {
  border-left-color: #0ea5e9;
}

.atendimento-card.status-finalizado {
  border-left-color: #10b981;
}

.atendimento-card.status-cancelado {
  border-left-color: #ef4444;
}

/* CARD HEADER */
.card-header {
  padding: 14px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.card-id {
  font-weight: 700;
  color: #d6582c;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-id i {
  font-size: 18px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.badge-solicitado {
  background: #fef3c7;
  color: #92400e;
}

.badge-andamento {
  background: #cffafe;
  color: #164e63;
}

.badge-finalizado {
  background: #d1fae5;
  color: #065f46;
}

.badge-cancelado {
  background: #fee2e2;
  color: #7f1d1d;
}

/* CARD CONTENT */
.card-content {
  padding: 16px;
}

.info-row {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
}

.info-row.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
}

.info-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.info-item i {
  font-size: 18px;
  color: #d6582c;
  margin-top: 2px;
  flex-shrink: 0;
}

.info-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.info-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
}

.queixa-text {
  color: #374151;
  line-height: 1.5;
  word-break: break-word;
}

/* CARD FOOTER */
.card-footer {
  padding: 12px 16px;
  background: #f8fafc;
  text-align: right;
  border-top: 1px solid #e5e7eb;
}

.view-link {
  font-size: 13px;
  font-weight: 700;
  color: #d6582c;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: all 0.3s ease;
}

.view-link i {
  font-size: 16px;
}

.atendimento-card:hover .view-link {
  gap: 10px;
  color: #e6744d;
}

/* EMPTY STATE */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
}

.empty-icon {
  font-size: 64px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 20px;
  color: #1f2937;
  margin-bottom: 8px;
  font-weight: 700;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.empty-action {
  color: #d6582c;
  margin-top: 12px !important;
  font-weight: 600;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .page-header {
    padding: 20px 16px 12px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .status-badge {
    align-self: flex-start;
  }

  .info-row.two-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .page-header {
    padding: 16px 12px 10px;
  }

  .page-title {
    font-size: 20px;
  }

  .cards-container {
    padding: 0 8px 100px;
  }

  .atendimento-card {
    margin-bottom: 12px;
  }

  .card-header {
    padding: 12px 14px;
  }

  .card-content {
    padding: 12px;
  }

  .info-row {
    margin-bottom: 12px;
  }

  .info-label {
    font-size: 11px;
  }

  .info-value {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UltimasSolicitacoes.vue